import type { RequestFn } from '../http';

/**
 * Adress-Vorschläge für Bestandskunden: Techniker schlagen vor,
 * Admin/Teamlead geben frei → Übernahme nach weclapp + Spiegel.
 */

export type AddressSuggestionStatus = 'PENDING' | 'APPROVED' | 'REJECTED';
export type AddressSuggestionKind = 'NEW' | 'UPDATE';

export interface AddressSuggestion {
  id: string;
  kind: AddressSuggestionKind;
  targetWeclappAddressId: string | null;
  street: string;
  street2: string | null;
  postalCode: string | null;
  city: string;
  countryCode: string;
  company: string | null;
  proposePrimary: boolean;
  proposeDelivery: boolean;
  note: string | null;
  source: string;
  status: AddressSuggestionStatus;
  reviewNote: string | null;
  reviewedAt: string | null;
  weclappAddressId: string | null;
  createdAt: string;
  customer: { id: string; name: string; weclappCustomerId: string | null };
  submittedBy: { displayName: string } | null;
  reviewedBy: { displayName: string } | null;
}

export interface SubmitAddressSuggestionInput {
  customerId?: string;
  weclappCustomerId?: string;
  kind?: AddressSuggestionKind;
  targetWeclappAddressId?: string | null;
  street: string;
  street2?: string | null;
  postalCode?: string | null;
  city: string;
  countryCode?: string;
  company?: string | null;
  proposePrimary?: boolean;
  proposeDelivery?: boolean;
  note?: string | null;
}

export interface DecideAddressSuggestionInput {
  reviewNote?: string | null;
  street?: string;
  street2?: string | null;
  postalCode?: string | null;
  city?: string;
  countryCode?: string;
  company?: string | null;
  proposePrimary?: boolean;
  proposeDelivery?: boolean;
}

export function createAddressSuggestionsApi(request: RequestFn) {
  return {
    async submitAddressSuggestion(input: SubmitAddressSuggestionInput) {
      return request<{ suggestion: AddressSuggestion }>('/address-suggestions', {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },

    async listAddressSuggestions(status?: AddressSuggestionStatus) {
      const qs = status ? `?status=${status}` : '';
      return request<{ suggestions: AddressSuggestion[] }>(`/address-suggestions${qs}`);
    },

    async listMyAddressSuggestions() {
      return request<{ suggestions: AddressSuggestion[] }>('/address-suggestions/mine');
    },

    async approveAddressSuggestion(id: string, input: DecideAddressSuggestionInput = {}) {
      // weclappPending: steht im ServiceHub, weclapp folgt über die Warteliste (v1.385.0).
      return request<{ suggestion: AddressSuggestion; weclappPending?: boolean }>(`/address-suggestions/${id}/approve`, {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },

    async rejectAddressSuggestion(id: string, reviewNote?: string) {
      return request<{ suggestion: AddressSuggestion }>(`/address-suggestions/${id}/reject`, {
        method: 'POST',
        body: JSON.stringify({ reviewNote }),
      });
    },
  };
}
